<template>
  <div class="pb-20">
    <AlertBanner :status="1">Interview request sent</AlertBanner>
    <div v-if="!isLoading" class="flex flex-col w-9/10 md:w-1/2 mx-auto mt-40 mb-40 sm:mb-0 p-16">
      <header class="font-medium text-m1">What's next?</header>
      <p class="mt-8 text-body">
        Your interview request has been sent. We'll email you when {{ sitterName }} accepts, declines, or does not confirm.
      </p>
      <div v-if="hasPhoto" class="flex flex-col">
        <header class="font-medium text-m1 mt-20">Prep for your interview</header>
        <Card class="mt-8" :clickable="true" href="/parents/babysitter-interview-checklist#">
          <p class="font-medium">Interview questions by topic</p>
          <p class="text-xs text-body mt-4">Blog post • 6 min read</p>
        </Card>
        <Card class="mt-16" :clickable="true" href="/parents/personality-traits-look-great-sitter">
          <p class="font-medium">4 personality traits to look for in a sitter or nanny</p>
          <p class="text-xs text-body mt-4">Blog post • 6 min read</p>
        </Card>
        <StickyButton class="sm:hidden" value="Done" btnVariant="outlined" :pageHasBottomNav="true" :to="'/bookings'" />
      </div>
      <div v-else class="flex flex-col mt-40 sm:mt-20 mb-40 sm:mb-0">
        <Card class="invisible-card flex flex-col p-0 sm:p-24">
          <header class="font-medium text-m1">Add a profile picture so {{ sitterName }} knows what you look like</header>
          <Avatar class="mx-auto mt-20" size="mega" :name="displayName" />
          <Button
            class="w-full md:w-2/3 lg:w-1/2 mx-auto mt-20"
            variant="primary"
            size="medium"
            href="/account/seekers/photo#/upload"
          >
            Upload profile photo
          </Button>
          <Button class="sm:hidden w-full mt-20" variant="outlined" size="small" :to="'/bookings'">Done</Button>
        </Card>
      </div>
      <Button class="hidden sm:block ml-auto mt-20" variant="outlined" size="small" :to="'/bookings'">Done</Button>
    </div>
  </div>
</template>

<script lang="ts">
import hasProfilePhoto from '@/helpers/bookings/bookingsAccountHelper';

// Components
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';
import Avatar from '@/components/avatar/Avatar.vue';
import Button from '@/components/button/Button.vue';
import Card from '@/components/card/Card.vue';
import StickyButton from '@/components/sticky_button/StickyButton.vue';

export default {
  name: 'WhatsNext',
  components: {
    AlertBanner,
    Avatar,
    Button,
    Card,
    StickyButton,
  },
  computed: {
    storeAccount() {
      return this.$store.getters['account/getAccount'];
    },
    isLoading(): boolean {
      return !this.storeAccount;
    },
    hasPhoto(): boolean {
      return hasProfilePhoto(this.storeAccount);
    },
    sitterName(): string {
      return this.$store.getters['interviewRequest/sitterDisplayName'] || 'the sitter';
    },
    displayName(): string {
      if (!this.storeAccount) return '';
      return `${this.storeAccount.firstName} ${this.storeAccount.lastName}`.trim();
    },
  },
  async mounted() {
    if (!this.storeAccount) {
      try {
        await this.$store.dispatch('account/fetchAccountData');
      } catch (error) {
        console.error('Error fetching account data:', error);
      }
    }
  },
};
</script>
<style lang="scss">
.invisible-card {
  @media (max-width: 479px) {
    box-shadow: none;
    transition: none;
    background: transparent;

    &:hover {
      box-shadow: none !important;
      transition: none !important;
    }
  }
}
</style>
